<template>
  <div class="informations-container">
    <div class="header">
      <h4 class="m-0 p-0">
        {{title}}
      </h4>
    </div>
    <div class="contentt">
      <div
          v-for="(information,index) in informations"
          :key="index"
          class="informations"
      >
        <b-checkbox
          v-model="information.value"
          :value="true"
          :unchecked-value="false"
          :class="colorSet[index]"
        >
          <div class="font-weight-normal">
            {{information.label}}
          </div>
        </b-checkbox>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "informations",

  props : {
    value : Array,
    title : {
      type: String,
      required: true,
    },
  },

  data(){
    return{
      informations: this.value,
      test: false,
      colorSet : ["C62CC91", "C465BFD", "CFF4247", "C81E8FF", "CFFC81E", "CFA7B1F", "C3C416B",
        "C5FB5FE", "C7F1FFA", "C767A9E", 'CBA98E'],
    }
  },

  watch : {
    value(){
      this.informations = this.value
    },

    informations(){
      this.$emit('input', this.informations)
    },
  },
}
</script>

<style lang="scss">

.custom-control.C62CC91{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #62CC91 !important;
    border-color: #62CC91 !important;
  }
}

.custom-control.C465BFD{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #465BFD !important;
    border-color: #465BFD !important;
  }
}

.custom-control.CFF4247{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #FF4247 !important;
    border-color: #FF4247 !important;
  }
}

.custom-control.C81E8FF{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #81E8FF !important;
    border-color: #81E8FF !important;
  }
}

.custom-control.CFFC81E{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #FFC81E !important;
    border-color: #FFC81E !important;
  }
}

.custom-control.CFA7B1F{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #FA7B1F !important;
    border-color: #FA7B1F !important;
  }
}

.custom-control.C3C416B{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #3C416B !important;
    border-color: #3C416B !important;
  }
}

.custom-control.C767A9E{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #767A9E !important;
    border-color: #767A9E !important;
  }
}


.custom-control.C7F1FFA{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #7F1FFA !important;
    border-color: #7F1FFA !important;
  }
}

.custom-control.C5FB5FE{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #5FB5FE !important;
    border-color: #5FB5FE !important;
  }
}

.custom-control.CBA98E{
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #CBA98E !important;
    border-color: #CBA98E !important;
  }
}

</style>